/** ********************Import required packages************** */
import styled from "styled-components";

export const LayoutStyled = styled.div`
  .sidebar {
    position: fixed;
    top: 0;
    left: 0px;
    height: 100%;
    width: 15.5rem;
    // background: #ffffff;
    z-index: 2;
    overflow: hidden;
    transition: all 0.4s ease-in-out;
    -webkit-transition: all 0.4s ease-in-out;
  }

  .sidebar-logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 3.7rem;
    padding-top: 0.6rem;
    background-color: transparent;
    margin-top: 13px;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
  }

  .menu-image {
    width: 1.2rem;
    height: 54px;
    // filter: invert(1);
  }

  .menu-item {
    text-decoration: none;
    color: black;
    width: 100%;
    padding-top: 0px;
    padding-bottom: 0px;
    padding-right: 10px;
    cursor: pointer;
    display: flex;
    padding-left: 1.5rem;
    height: 45px;
  }

  .menu-item > img {
    width: 1.2rem;
    height: 54px;
    // filter: invert(1);
  }

  .menu-item:hover {
    // border-right: 3px solid #00aeff;
    color: #025963 !important;
    // background: linear-gradient(90deg, #008cff -2.08%, #4233b0 97.92%);
  }

  // .menu-image:hover {
  //   filter: brightness(0) invert(1);
  // }

  .sidebar.close {
    width: 80px;
    overflow: inherit;
    transition: all 0.4s ease-in-out;
    -webkit-transition: all 0.4s ease-in-out;
  }

  .active-route {
    background-color: white !important;
    border-radius: 8px;
   
  
  }
  .active-color .link-name{
    color: #025963 !important;
    background:white !important;
  }


  .sidebar .logo-details {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
  }

  .sidebar .logo-details i {
    font-size: 30px;
    color: black;
    height: 50px;
    min-width: 78px;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
  }

  .sidebar .logo-details .logo_name {
    font-size: 22px;
    color: black;
    font-weight: 600;
    transition: 0.3s ease;
    transition-delay: 0.1s;
  }

  .sidebar.close .logo-details .logo_name {
    transition-delay: 0s;
    opacity: 0;
    pointer-events: none;
  }

  .sidebar.close.nav-links {
    overflow: visible;
  }

  .sidebar .nav-links {
    height: 88vh;
    padding: 0px 0 150px 0;
    overflow: auto;
    margin-top: 5px;
  }

  .background-color {
    overflow: hidden;
    display: flex;
    align-items: center;
  }

  .sidebar .nav-links::-webkit-scrollbar {
    display: none;
    overflow-y: auto;
  }

  .close .nav-links {
    overflow: visible;
    background: transparent;
  }

  .open .nav-links {
    overflow: scroll;
    height: 88vh;
    margin-bottom: 27px;
    background: transparent;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .ps {
    overflow: hidden !important;
    overflow-anchor: none;
    -ms-overflow-style: none;
    touch-action: auto;
  }

  .sidebar .nav-links li {
    position: relative;
    list-style: none;
    transition: all 0.35s ease;
    padding-left: 15px;
  }

  .sidebar .nav-links li .iocn-links {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .sidebar .nav-links li i {
    height: 50px;
    min-width: 78px;
    text-align: center;
    line-height: 50px;
    font-size: 20px;
    color: black;
    cursor: pointer;
    transform: all 0.35s ease;
  }

  .sidebar .nav-links li.showMenu i.arrow {
    transform: rotate(-180deg);
  }

  .inmaximize.sidebar .nav-links li.showMenu .active-route{
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .sidebar.close .nav-links i.arrow {
    display: none;
  }

  .sidebar .nav-links li a {
    display: flex;
    align-items: center;
    text-decoration: none;
  }
  


  /* ===== Handle Submenu while minimized ===== */
  .sidebar .nav-links li a .link-name {
    font-size: 16px;
    font-weight: 400;
    width: 100%;
    padding-left: 1.3rem;
    height: 55px;
    display: flex;
    align-items: center;
    transition: width 0.4s ease-in-out;
    color: #000000;
  }
  .sub-menu-active {
    height: 30px !important;
    color: #4233b0 !important;
    background-color: #EDF8F9 !important;
    border-radius: 8px !important;
  }

  .icons-dynamic{
    color:#000000 !important;
    height:unset !important;
    min-width:unset !important;
    font-size:24px !important;
  }


  .sidebar .nav-links li a .link-name-submenu {
    font-size: 16px;
    font-weight: 400;
    width: 100%;
    padding-left: 1rem;
    height: 45px;
    display: flex;
    align-items: center;
    transition: width 0.4s ease-in-out;
    color: #025963!important;
  }

  // .sidebar .nav-links .submenu.minimized  li{
  //    padding-left: 0rem !important;
  // }

  .link-name-submenu.minimized.active-route.sub-menu-active{
    background-color:white !important;
  }
  .active-route > .link-name-submenu {
    color: #025963 !important;
  }

  .sidebar .close .nav-links li a .link-name {
    opacity: 0;
    pointer-events: none;
  }

  .sidebar .nav-links li .submenu {
    // padding: 6px 6px 14px 80px;
    /* margin-top: -10px; */
    background-color: #ffffff;
    color: white;
    display: none;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    padding: 5px;
  }

  .sidebar .nav-links li .submenu.minimized {
    background-color: #EDF8F9;
  }

  .sidebar .nav-links li.showMenu .submenu {
    display: block;
  }

  .sidebar .nav-links li .submenu a {
    color: black;
    font-size: 15px;
    /* padding: 0.5rem 0 0 1rem; */
    white-space: nowrap;
    transition: all 0.35s ease;
  }
  .sub-menu-height {
    height: 45px !important;
  }

  .sidebar.close .nav-links li a .link-name {
    display: none;
  }

  .sidebar.close .nav-links li i .link-name:hover {
    width: inherit;
    display: block;
  }

  .sidebar.close .nav-links li .submenu {
    position: absolute;
    left: 100%;
    top: -5px;
    margin-top: 0;
    border-radius: 0 6px 6px 0;
    display: block;
    opacity: 0;
    pointer-events: none;
    transition: 0s;
    min-width: 14rem;
    line-height: 40px;
    padding-left: 0px;
  }

  .sidebar.close .nav-links li:hover .submenu {
    opacity: 1;
    pointer-events: auto;
    transition: all 0.35s ease;
    padding-left: 0px;
  }

  .sidebar .nav-links li .submenu .link-name {
    display: none;
  }

  .sidebar.close .nav-links li .submenu .link-name {
    font-size: 16px;
    opacity: 1;
    display: flex;
  }

  .inmaximize.showMenu div a.menu-item.active {
    background-color: #dce8e9;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .sidebar .nav-links li .submenu .blank {
    opacity: 1;
    pointer-events: auto;
    padding: 3px 20px 6px 16px;
    opacity: 0;
    pointer-events: none;
  }

  .sidebar .nav-links a:hover .submenu .blank {
    top: 50%;
    transition: translateY(-50%);
    background-color: green;
  }



  .Home-section {
    position: relative;
    background-color: #EDF8F9;
    // height: 100vh;
    left: 260px;
    overflow-x:hidden;
    overflow-y:auto;
    width: calc(100% - 260px);
    transition: all 0.5s ease;
  }

  .sidebar.close ~ .Home-section {
    left: 78px;
    width: calc(100% - 78px);
  }

  .Home-section .home-content {
    height: 60px;
    display: flex;
    align-items: center;
  }

  .Home-section .home-content .bx-menu,
  .Home-section .home-content .text {
    color: #11101d;
    font-size: 35px;
  }

  .Home-section .home-content .text {
    font-size: 16px;
    font-weight: 400;
  }

  .Home-section .home-content .bx-menu {
    margin: 0 15px;
    cursor: pointer;
  }

  .scroll-active {
    overflow-y: visible scroll !important;
  }

  .scroll-inactive {
    overflow: visible !important;
    padding: 0px 0 150px 0 !important;
    margin-top: 10px !important;
  }

  .margin {
    margin-right: 7%;
    cursor: pointer;
  }

  .Home-section {
    position: relative;
    background-color: #EDF8F9;
    height: 100vh;
    left: 15.3rem;
    width: calc(100% - 15.3rem);
    transition: all 0.4s ease-in-out;
  }
  .active-route .icons-dynamic{
    color:#ffffff !important
  }
  .active-route .link-name{
    color:#025963 !important
  }


  .home-content {
    background: #f8f9fc;
    position: sticky;
    top: 0;
    z-index: 1;
    // box-shadow: rgb(149 157 165 / 20%) 0px 1px 7px;
  }

  .menu-icon {
    color: black;
    cursor: pointer;
    width: 24px;
    height: 24px;
    margin-right: 0.5rem;
  }

  .Home-section .home-content {
    height: 60px;
    display: flex;
    align-items: center;
  }

  .Home-section .home-content .bx-menu,
  .Home-section .home-content .text {
    color: #11101d;
    font-size: 35px;
  }

  .Home-section .home-content .text {
    font-size: 16px;
    font-weight: 400;
  }

  .Home-section .home-content .bx-menu {
    margin: 0 15px;
    cursor: pointer;
  }

  .sidebar.close ~ .Home-section {
    left: 80px;
    width: calc(100% - 80px);
  }
  .link-name:hover {
    color: #025963 !important;
    bground-color: white !important;
  }
`;